import dayjs from "dayjs";

// F29: a certificate shows the completion's day in the enrolment's time zone,
// the day the bulk certificate PDFs print. The API gives it as
// certificateDate ("YYYY-MM-DD"); it is read as that calendar day wherever
// the learner is. Without it (an older API) the completion date is used.
export const certificateDateOf = (record) =>
  record?.certificateDate
    ? dayjs(record.certificateDate).toDate()
    : new Date(record?.completionDate);

// A "YYYY-MM-DD" day as a Date at local midnight (for date pickers), and back.
export const dayToDate = (day) => (day ? dayjs(day).toDate() : null);
export const dateToDay = (date) => (date ? dayjs(date).format("YYYY-MM-DD") : null);
